import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import Header from '../../../../main/headers/header';
import AdminUserSearchBox from '../../../../main/search/adminUserSearchBox';
import { USER_TYPES } from '../../../../auth/constants';

const Users = ({ children, isSuperAdmin, addLinkKind }) => (
  <div>
    <Header heading="Users" type="user" button="Add user" link={`/admin/users/add?kind=${addLinkKind}`}>
      <div className="c-header-primary__components">
        <AdminUserSearchBox type="user" />
      </div>
    </Header>
    <div className="c-wrapper o-page-height">
      <div className="c-tab-items u-mb-" display-if={isSuperAdmin}>
        <Link className="c-nav-tab" activeClassName="is-active" to="/admin/users" onlyActiveOnIndex>
          Users
        </Link>
        <Link className="c-nav-tab" activeClassName="is-active" to="/admin/users/admin-users">
          Admin & Agent Users
        </Link>
      </div>
      {children}
    </div>
  </div>
);

Users.propTypes = {
  children: PropTypes.node,
  isSuperAdmin: PropTypes.bool,
  addLinkKind: PropTypes.number,
};

Users.defaultProps = {
  children: null,
  isSuperAdmin: false,
  addLinkKind: USER_TYPES.shop,
};

export default Users;
